import { render, staticRenderFns } from "./BchOrderRedeemDrawer.vue?vue&type=template&id=7e526786&scoped=true"
import script from "./BchOrderRedeemDrawer.vue?vue&type=script&lang=js"
export * from "./BchOrderRedeemDrawer.vue?vue&type=script&lang=js"
import style0 from "./BchOrderRedeemDrawer.vue?vue&type=style&index=0&id=7e526786&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e526786",
  null
  
)

export default component.exports